export const pairKey = (commodity, market) => `${commodity}_${market}`;

/**
 * Turns a saved chat's messages into the dialog's turn list. Each user message
 * is followed by one assistant message per commodity/market pair it was asked for.
 */
export function messagesToTurns(messages) {
    let question = null;
    const turns = [];
    for (const message of messages || []) {
        if (message.user_id !== 'assistant') {
            question = message.message;
            continue;
        }
        turns.push({
            id: `saved-${message.id}`,
            commodity: message.commodity,
            market: message.market,
            question,
            message: message.message,
            citations: message.citations || '',
            citedCount: undefined,
            isStreaming: false,
            startedAt: null,
            endedAt: null,
            elapsed: null,
            errorMessage: null,
            cancelled: false,
        });
    }
    return turns;
}

/** Last saved response id per pair, so the next question for that pair continues its thread. */
export function lastResponseIdsByPair(messages) {
    const responseIds = {};
    for (const message of messages || []) {
        if (message.user_id === 'assistant' && message.openai_response_id) {
            responseIds[pairKey(message.commodity, message.market)] = message.openai_response_id;
        }
    }
    return responseIds;
}

/** Rewrites citation markers to the References numbering and strips leftover raw markers. */
export function finalizeAnswer(text, annotationMap = {}) {
    let message = text;
    const markers = Object.keys(annotationMap);
    // Replace longest markers first to avoid partial-match issues
    markers.sort((a, b) => b.length - a.length);
    for (const marker of markers) {
        message = message.split(marker).join(`[${annotationMap[marker]}]`);
    }
    message = message.replace(/【\d+:\d+†[^】]*】/g, '');
    return message.replace(/(\[\d+\])\1+/g, '$1');
}

/** Newest chat first, by creation time. */
export function sortChatsNewestFirst(chats) {
    return [...(chats || [])].sort((a, b) => new Date(b.created_date || 0) - new Date(a.created_date || 0));
}
